module.exports = __webpack_public_path__ + "static/media/about-honors.78087598.png";